import { clsx } from "clsx";
import { type ReactNode, type PropsWithChildren } from "react";

export const Tabs = ({ children }: { children: ReactNode[] }) => {
  return (
    <div className="flex h-10 items-center gap-4 rounded-full bg-interface-neutral-2 p-1">
      {children}
    </div>
  );
};

type ItemProps = PropsWithChildren<{
  isActive?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}>;

const Item = ({
  children,
  onClick,
  isActive = false,
  disabled = false,
  ...props
}: ItemProps) => {
  return (
    <button
      type="button"
      className={clsx("flex h-full items-center gap-2 rounded-full px-4", {
        "bg-interface-neutral-0 font-semibold text-interface-neutral-6 shadow-md":
          isActive,
        "bg-interface-neutral-2 text-interface-neutral-5": !isActive
      })}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

Tabs.Item = Item;

const ItemColor = ({ className }: { className: string }) => {
  return <span className={clsx("size-3 rounded-full", className)} />;
};

Tabs.ItemColor = ItemColor;

const ItemCount = ({ count }: { count?: number }) => {
  if (count === undefined) return null;

  return <span className="!font-normal text-interface-neutral-4">{count}</span>;
};

Tabs.ItemCount = ItemCount;
